import {Col, Form, Row} from 'react-bootstrap'
import Select from 'react-select'
import {COUNTRIES, MARITAL_STATUS} from '../../../../../helpers/consts'
import {TFormMemberPolicy} from '../../../../policies/policiesTypes'

interface SpecificInformationMemberProps {
  membernum: number
  values: TFormMemberPolicy
  handleChange: (field: string, value: string) => void
}

export const SpecificInformationMember: React.FC<SpecificInformationMemberProps> = ({
  membernum,
  values,
  handleChange,
}) => {
  // console.log('SpecificInformationMember:' + JSON.stringify(values))
  return (
    <Row>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`maritalStatus_${membernum}`}>Marital status</Form.Label>
          <Form.Select
            name={`maritalStatus_${membernum}`}
            id={`maritalStatus_${membernum}`}
            value={values.maritalStatus ?? ''}
            onChange={(e) => handleChange('maritalStatus', e.target.value)}
            aria-label='Default select example'
          >
            <option value=''>Select one</option>
            {MARITAL_STATUS.map((mari) => (
              <option key={mari} value={mari}>
                {mari}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`countryBirth_${membernum}`}>Country of birth</Form.Label>
          <Select
            inputId={`countryBirth_${membernum}`}
            value={COUNTRIES.find((opt) => opt.value === values.countryBirth) || null}
            onChange={(option) => {
              const value = option ? option.value : ''
              handleChange('countryBirth', value)
            }}
            options={COUNTRIES}
            styles={{control: (base) => ({...base, padding: '3px 0'})}}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`weight_${membernum}`}>Weight (kg)</Form.Label>
          <Form.Control
            type='number'
            value={values.weight ?? ''}
            name={`weight_${membernum}`}
            id={`weight_${membernum}`}
            placeholder='Enter weight'
            onChange={(e) => {
              handleChange('weight', e.target.value)
            }}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label htmlFor={`height_${membernum}`}>Height (cm)</Form.Label>
          <Form.Control
            type='number'
            value={values.height ?? ''}
            name={`height_${membernum}`}
            id={`height_${membernum}`}
            placeholder='Enter height'
            onChange={(e) => {
              handleChange('height', e.target.value)
            }}
          />
        </Form.Group>
      </Col>
    </Row>
  )
}
